module.exports = __webpack_public_path__ + "img/icon-tel.svg?f0349524d4c8124167ecd29c7da596e9";